import React from 'react';
import { IconButton as IconButtonNew } from './IconButton';
import { convertOldIconButtonProps } from './converter.old';
import type { OldIconButtonProps } from './converter.old';

export type IconButtonProps = OldIconButtonProps;

export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>((props, ref) => {
  return <IconButtonNew {...convertOldIconButtonProps(props)} ref={ref} />;
});
